
import Chart from 'chart.js/dist/Chart.js';

export default {
	props: {
		chartdata: {
			type: Object,
			default: null
		},
		options: {
			type: Object,
			default: null
		}
	},
	mounted() {
		const ctx = this.$refs.chart.getContext('2d');
		new Chart(ctx, {
			type: 'bar',
			data: this.chartdata,
			options: {
				...this.options,
				scales: {
					yAxes: [{
						ticks: {
							callback: function(value) {
								return new Intl.NumberFormat('nl-BE').format(value);
							}
						}
					}]
				},
				tooltips: {
					callbacks: {
						label: function(tooltipItem) {
							return new Intl.NumberFormat('nl-BE').format(tooltipItem.yLabel);
						}
					}
				}
			}
		});
	}
};
